
//首页信息
const index = {

    // 用户数据
    userData:[
        {
            name:'',
            count:'10',
            unit:'M+',
            type:['注册玩家','注册玩家','Number of players'],
            imgURL:'../../../static/img/ui_1.png',
            bgColor:'#58bd95'
        },
        {
            name:'',
            count:'100',
            unit:'K+',
            type:['活跃玩家','活跃玩家','Active user'],
            imgURL:'../../../static/img/ui_2.png',
            bgColor:'#3b3b63'
        },
        {
            name:'',
            count:'>60',
            unit:'%',
            type:['次日留存','次日留存','Next day retention'],
            imgURL:'../../../static/img/ui_3.png',
            bgColor:'#5e94f1'
        },
        {
            name:'',
            count:'90',
            unit:'Days+',
            type:['平均留存日数','平均留存日數','Averaging days'],
            imgURL:'../../../static/img/ui_4.png',
            bgColor:'#ddb65f'
        },
        {
            name:'',
            count:'140k',
            unit:'Hours+',
            type:['每日游戏时间','每日游戏时间','One day playtime'],
            imgURL:'../../../static/img/ui_5.png',
            bgColor:'#ed6172'
        },
        {
            name:'',
            count:'5',
            unit:'M+',
            type:['广告日显示量','广告日显示量','One day advertising display'],
            imgURL:'../../../static/img/ui_6.png',
            bgColor:'#5a599a'
        },
    ],
}
// 游戏信息配置
const games = {
    bpd:{
        gameKey:'bpd',
        name:['每日方块','每日方块','Block Puzzle Daily',],
        subTitle:['畅玩方块拼图游戏，匹配颜色，轻松解压！','畅玩方块拼图游戏，匹配颜色，轻松解压！','畅玩方块拼图游戏，匹配颜色，轻松解压！',],
        info:[
            '方块拼图-免费经典益智游戏，匹配颜色，消除方块！<br><br>方块拼图是一款免费且令人上瘾的休闲益智游戏，让你每天都想来玩！🧩如果您想放松身心，享受片刻闲暇，这款游戏一定是你的不二之选。🏆畅玩方块拼图，放松你的大脑！<br><br>方块拼图适合所有年龄段玩家。👑如果你想在辛苦工作一天后放松身心，早点入睡，这款游戏一定是你的不二之选！畅玩方块拼图，充分展示游戏技巧，体验最高七次连击带来的快感！<br><br>💡亮点特色💡<br>- 简洁美观，无时间限制，轻松无压力。<br>- 上手简单，适合全年龄段玩家的经典方块游戏！<br>- 挑战自我，打破你的最高分。<br>- 多种精美背景。<br>- 多样化方块质地：木制、糖果、宝石、珠宝......<br>- 实用道具助你打破最高分。<br>- 锻炼大脑，消磨时间的不二之选。<br><br>🌟如何玩🌟<br>- 匹配并消除尽可能多的彩色方块！<br>- 沿垂直或水平方向填充方块即可消除。<br>- 无时间限制！<br>- 简单有趣！<br><br>方块拼图适合所有年龄段玩家，免费畅玩！<br><br>我们的方块拼图游戏支持离线游玩，结合了1010脑力游戏、数独方块游戏、三消立方体游戏和木块拼图游戏元素，帮助你锻炼大脑。🧠 运用你的智慧和策略来消除彩色方块，立即享受方块拼图挑战吧！<br><br>❤️谁是最厉害的方块消除者？快来玩这款游戏，成为方块益智游戏大师吧！' ,   
            '方块拼图-免费经典益智游戏，匹配颜色，消除方块！<br><br>方块拼图是一款免费且令人上瘾的休闲益智游戏，让你每天都想来玩！🧩如果您想放松身心，享受片刻闲暇，这款游戏一定是你的不二之选。🏆畅玩方块拼图，放松你的大脑！<br><br>方块拼图适合所有年龄段玩家。👑如果你想在辛苦工作一天后放松身心，早点入睡，这款游戏一定是你的不二之选！畅玩方块拼图，充分展示游戏技巧，体验最高七次连击带来的快感！<br><br>💡亮点特色💡<br>- 简洁美观，无时间限制，轻松无压力。<br>- 上手简单，适合全年龄段玩家的经典方块游戏！<br>- 挑战自我，打破你的最高分。<br>- 多种精美背景。<br>- 多样化方块质地：木制、糖果、宝石、珠宝......<br>- 实用道具助你打破最高分。<br>- 锻炼大脑，消磨时间的不二之选。<br><br>🌟如何玩🌟<br>- 匹配并消除尽可能多的彩色方块！<br>- 沿垂直或水平方向填充方块即可消除。<br>- 无时间限制！<br>- 简单有趣！<br><br>方块拼图适合所有年龄段玩家，免费畅玩！<br><br>我们的方块拼图游戏支持离线游玩，结合了1010脑力游戏、数独方块游戏、三消立方体游戏和木块拼图游戏元素，帮助你锻炼大脑。🧠 运用你的智慧和策略来消除彩色方块，立即享受方块拼图挑战吧！<br><br>❤️谁是最厉害的方块消除者？快来玩这款游戏，成为方块益智游戏大师吧！' ,   
            '方块拼图-免费经典益智游戏，匹配颜色，消除方块！<br><br>方块拼图是一款免费且令人上瘾的休闲益智游戏，让你每天都想来玩！🧩如果您想放松身心，享受片刻闲暇，这款游戏一定是你的不二之选。🏆畅玩方块拼图，放松你的大脑！<br><br>方块拼图适合所有年龄段玩家。👑如果你想在辛苦工作一天后放松身心，早点入睡，这款游戏一定是你的不二之选！畅玩方块拼图，充分展示游戏技巧，体验最高七次连击带来的快感！<br><br>💡亮点特色💡<br>- 简洁美观，无时间限制，轻松无压力。<br>- 上手简单，适合全年龄段玩家的经典方块游戏！<br>- 挑战自我，打破你的最高分。<br>- 多种精美背景。<br>- 多样化方块质地：木制、糖果、宝石、珠宝......<br>- 实用道具助你打破最高分。<br>- 锻炼大脑，消磨时间的不二之选。<br><br>🌟如何玩🌟<br>- 匹配并消除尽可能多的彩色方块！<br>- 沿垂直或水平方向填充方块即可消除。<br>- 无时间限制！<br>- 简单有趣！<br><br>方块拼图适合所有年龄段玩家，免费畅玩！<br><br>我们的方块拼图游戏支持离线游玩，结合了1010脑力游戏、数独方块游戏、三消立方体游戏和木块拼图游戏元素，帮助你锻炼大脑。🧠 运用你的智慧和策略来消除彩色方块，立即享受方块拼图挑战吧！<br><br>❤️谁是最厉害的方块消除者？快来玩这款游戏，成为方块益智游戏大师吧！' ,   
            ],
        appleURL:'https://apps.apple.com/us/app/block-crush-daily/id6477366153',
        googleURL:'https://play.google.com/store/apps/details?id=com.bigcake.android.bpdaily&gl=US&hl=en-US&pli=1',
        downloads:'10M+',
        imgURL:'../../static/img/games/bpd_icon.png',
        posterImgURL:'../../../static/img/games/bpd-poster-img.png',
        comments:[ // 一组三个图片，刚好一行
            [
                '../../static/img/games/user-comment2.bpd.png',
                '../../static/img/games/user-comment3.bpd.png',
                '../../static/img/games/user-comment4.bpd.png',
            ], [
                '../../static/img/games/user-comment6.bpd.png',
                '../../static/img/games/user-comment7.bpd.png',
                '../../static/img/games/user-comment8.bpd.png',
            ],
        ],
    },
    dnm:{
        gameKey:'dnm',
        name:['每日数字配对','每日数字配对','Daily Number Match',],
        subTitle:['令人上瘾且放松的每日数字匹配为您带来无尽的乐趣。','令人上瘾且放松的每日数字匹配为您带来无尽的乐趣。','令人上瘾且放松的每日数字匹配为您带来无尽的乐趣。',],
        info:[
            '每日数字配对是一款充满乐趣且令人上瘾的数字配对游戏。匹配数字，清除棋盘。磨练你的思维，享受乐趣，同时提升你的数学技能！🔢 数千个数字谜题等你来挑战！<br><br>玩法<br>- 找到数值相同或和为 10 的数字对。<br>- 逐行检查。记住，数字对可以是垂直、水平或对角线。<br>- 从左到右逐行扫描。注意一行末尾和另一行开头的数字对。只要它们之间没有数字，就可以消除！<br>- 清除一行即可将剩余的数字上移，并组成新的数字对。<br>- 当没有剩余的数字对时，点击“+”复制剩余的数字并组成更多数字对。<br>- 最终目标是清除棋盘，尽可能走得更远。<br>特色：<br>- 简单的游戏玩法：只需点击数字，即可消除所有数字！<br>- 无限乐趣：超过 10000 个关卡等你来挑战。<br>- 极简设计：纯粹的数字匹配游戏，没有令人分心的功能。<br>- 锻炼你的思维：通过具有挑战性的每日数字匹配来锻炼你的大脑。<br>- 随时随地畅玩：没有时间限制！无需Wi-Fi！<br><br>每日数字匹配是一款富有挑战性的益智游戏，旨在满足你的所有期望。💯如果你是一位数学迷，正在寻找一款纯粹的数学益智游戏，没有烦人的功能，那么每日数字匹配绝对适合你！🎯<br><br>如果你被日常生活压得喘不过气来，让每日数字匹配为你注入活力，训练你的大脑，放松你的思绪。别再犹豫了！立即下载，享受无尽的乐趣！' ,   
            '每日数字配对是一款充满乐趣且令人上瘾的数字配对游戏。匹配数字，清除棋盘。磨练你的思维，享受乐趣，同时提升你的数学技能！🔢 数千个数字谜题等你来挑战！<br><br>玩法<br>- 找到数值相同或和为 10 的数字对。<br>- 逐行检查。记住，数字对可以是垂直、水平或对角线。<br>- 从左到右逐行扫描。注意一行末尾和另一行开头的数字对。只要它们之间没有数字，就可以消除！<br>- 清除一行即可将剩余的数字上移，并组成新的数字对。<br>- 当没有剩余的数字对时，点击“+”复制剩余的数字并组成更多数字对。<br>- 最终目标是清除棋盘，尽可能走得更远。<br>特色：<br>- 简单的游戏玩法：只需点击数字，即可消除所有数字！<br>- 无限乐趣：超过 10000 个关卡等你来挑战。<br>- 极简设计：纯粹的数字匹配游戏，没有令人分心的功能。<br>- 锻炼你的思维：通过具有挑战性的每日数字匹配来锻炼你的大脑。<br>- 随时随地畅玩：没有时间限制！无需Wi-Fi！<br><br>每日数字匹配是一款富有挑战性的益智游戏，旨在满足你的所有期望。💯如果你是一位数学迷，正在寻找一款纯粹的数学益智游戏，没有烦人的功能，那么每日数字匹配绝对适合你！🎯<br><br>如果你被日常生活压得喘不过气来，让每日数字匹配为你注入活力，训练你的大脑，放松你的思绪。别再犹豫了！立即下载，享受无尽的乐趣！' ,   
            '每日数字配对是一款充满乐趣且令人上瘾的数字配对游戏。匹配数字，清除棋盘。磨练你的思维，享受乐趣，同时提升你的数学技能！🔢 数千个数字谜题等你来挑战！<br><br>玩法<br>- 找到数值相同或和为 10 的数字对。<br>- 逐行检查。记住，数字对可以是垂直、水平或对角线。<br>- 从左到右逐行扫描。注意一行末尾和另一行开头的数字对。只要它们之间没有数字，就可以消除！<br>- 清除一行即可将剩余的数字上移，并组成新的数字对。<br>- 当没有剩余的数字对时，点击“+”复制剩余的数字并组成更多数字对。<br>- 最终目标是清除棋盘，尽可能走得更远。<br>特色：<br>- 简单的游戏玩法：只需点击数字，即可消除所有数字！<br>- 无限乐趣：超过 10000 个关卡等你来挑战。<br>- 极简设计：纯粹的数字匹配游戏，没有令人分心的功能。<br>- 锻炼你的思维：通过具有挑战性的每日数字匹配来锻炼你的大脑。<br>- 随时随地畅玩：没有时间限制！无需Wi-Fi！<br><br>每日数字匹配是一款富有挑战性的益智游戏，旨在满足你的所有期望。💯如果你是一位数学迷，正在寻找一款纯粹的数学益智游戏，没有烦人的功能，那么每日数字匹配绝对适合你！🎯<br><br>如果你被日常生活压得喘不过气来，让每日数字匹配为你注入活力，训练你的大脑，放松你的思绪。别再犹豫了！立即下载，享受无尽的乐趣！' ,   
            ],
        appleURL:'#',
        googleURL:'https://play.google.com/store/apps/details?id=daily.number.match.free.puzzle&gl=US&hl=en-US&pli=1',
        downloads:'10M+',
        imgURL:'../../static/img/games/dnm_icon.png',
        posterImgURL:'../../../static/img/games/dnm-poster-img.png',
        comments:[
            [
                '../../static/img/games/user-comment2.dnm.png',
                '../../static/img/games/user-comment3.dnm.png',
                '../../static/img/games/user-comment4.dnm.png',
            ], [
                '../../static/img/games/user-comment6.dnm.png',
                '../../static/img/games/user-comment7.dnm.png',
                '../../static/img/games/user-comment8.dnm.png',
            ],
        ],
    },
    ssc:{
        gameKey:'ssc',
        name:['蜘蛛纸牌','蜘蛛纸牌','Spider Solitaire Classic',],
        subTitle:['有趣又轻松的蜘蛛纸牌训练你的大脑！','有趣又轻松的蜘蛛纸牌训练你的大脑！','有趣又轻松的蜘蛛纸牌训练你的大脑！',],
        info:[
            '💥经典蜘蛛纸牌的全新版本正等你来！💥<br><br>每日蜘蛛纸牌经典版是一款能够离线游玩的免费游戏！🍵 为所有玩家带来快乐！如果你想训练你的大脑，让你的思维更加灵活，每日蜘蛛纸牌经典版就是你的最佳选择！🧠<br><br>特色：<br>🎮 玩法经典：每日蜘蛛纸牌经典版带你回到童年。<br><br>🌸 图形美丽：海量美丽背景，卡背，卡面，自定义你的游戏体验。<br><br>🔢 难易由人：选择1,2或4种花色，磨砺头脑，挑战更高难度！<br><br>🎯 每日挑战：每天一个新的牌局，测试你的技巧。<br><br>你是经典纸牌游戏爱好者吗？你在寻找一个游戏来锻炼你的战略思维吗？🔎 每日蜘蛛纸牌经典版绝对是你想要的！<br><br>和每日蜘蛛纸牌经典版一起踏上休闲之旅。🌎 让这个引人入胜的游戏放松你的心情，同时训练你的大脑！<br><br>如果你喜欢克朗代克，空当接龙，金字塔纸牌，二十一点和其他纸牌游戏，或其他益智游戏，你绝对不能错过这款每日蜘蛛纸牌经典版！<br><br>⬇️ 现在下载&享受！' ,   
            '💥经典蜘蛛纸牌的全新版本正等你来！💥<br><br>每日蜘蛛纸牌经典版是一款能够离线游玩的免费游戏！🍵 为所有玩家带来快乐！如果你想训练你的大脑，让你的思维更加灵活，每日蜘蛛纸牌经典版就是你的最佳选择！🧠<br><br>特色：<br>🎮 玩法经典：每日蜘蛛纸牌经典版带你回到童年。<br><br>🌸 图形美丽：海量美丽背景，卡背，卡面，自定义你的游戏体验。<br><br>🔢 难易由人：选择1,2或4种花色，磨砺头脑，挑战更高难度！<br><br>🎯 每日挑战：每天一个新的牌局，测试你的技巧。<br><br>你是经典纸牌游戏爱好者吗？你在寻找一个游戏来锻炼你的战略思维吗？🔎 每日蜘蛛纸牌经典版绝对是你想要的！<br><br>和每日蜘蛛纸牌经典版一起踏上休闲之旅。🌎 让这个引人入胜的游戏放松你的心情，同时训练你的大脑！<br><br>如果你喜欢克朗代克，空当接龙，金字塔纸牌，二十一点和其他纸牌游戏，或其他益智游戏，你绝对不能错过这款每日蜘蛛纸牌经典版！<br><br>⬇️ 现在下载&享受！' ,   
            '💥经典蜘蛛纸牌的全新版本正等你来！💥<br><br>每日蜘蛛纸牌经典版是一款能够离线游玩的免费游戏！🍵 为所有玩家带来快乐！如果你想训练你的大脑，让你的思维更加灵活，每日蜘蛛纸牌经典版就是你的最佳选择！🧠<br><br>特色：<br>🎮 玩法经典：每日蜘蛛纸牌经典版带你回到童年。<br><br>🌸 图形美丽：海量美丽背景，卡背，卡面，自定义你的游戏体验。<br><br>🔢 难易由人：选择1,2或4种花色，磨砺头脑，挑战更高难度！<br><br>🎯 每日挑战：每天一个新的牌局，测试你的技巧。<br><br>你是经典纸牌游戏爱好者吗？你在寻找一个游戏来锻炼你的战略思维吗？🔎 每日蜘蛛纸牌经典版绝对是你想要的！<br><br>和每日蜘蛛纸牌经典版一起踏上休闲之旅。🌎 让这个引人入胜的游戏放松你的心情，同时训练你的大脑！<br><br>如果你喜欢克朗代克，空当接龙，金字塔纸牌，二十一点和其他纸牌游戏，或其他益智游戏，你绝对不能错过这款每日蜘蛛纸牌经典版！<br><br>⬇️ 现在下载&享受！' ,   
            ],
        appleURL:'https://apps.apple.com/us/app/classic-spider-solitaire-mania/id1584596271',
        googleURL:'https://play.google.com/store/apps/details?id=solitaire.spider.card.free.mania&gl=US&hl=en-US&pli=1',
        downloads:'10M+',
        imgURL:'../../static/img/games/ssc_icon.png',
        posterImgURL:'../../../static/img/games/ssc-poster-img.png',
        comments:[
            [
                '../../static/img/games/user-comment2.ssc.png',
                '../../static/img/games/user-comment3.ssc.png',
                '../../static/img/games/user-comment4.ssc.png',
            ], [
                '../../static/img/games/user-comment6.ssc.png',
                '../../static/img/games/user-comment7.ssc.png',
                '../../static/img/games/user-comment8.ssc.png',
            ],
        ],
    },
    jp:{
        gameKey:'jp',
        name:['拼图','拼图','Jigsaw Puzzles',],
        subTitle:['海量美丽的拼图游戏等着你去探索！休息并放松一下','海量美丽的拼图游戏等着你去探索！休息并放松一下','海量美丽的拼图游戏等着你去探索！休息并放松一下',],
        info:[
            '欢迎来到美妙的拼图世界，成千上万款拼图游戏让你远离生活烦恼，找回内心平静，享受轻松时光！您可以通过选择碎片数来选择每个谜题的难度。此外，拼图应用十分便携，内含各种拼图游戏，却不会有任何碎片丢失。每天都一起拼出明亮而有魔力的全新拼图，享受无穷乐趣！<br><br>🧩特点：<br>- 每日拼图:每天更新免费拼图,试试解开它<br>- 没有丢失的碎片:根据需要完成每个拼图高清拼图，因为根本没有丢失的碎片。<br>- 难度选择:选择不同碎片数量。碎片越多，游戏越难,成为拼图高手!<br>- 各种系列图片:动物,风景,美食,花卉,房屋,地标等<br>- 自定义背景：选择在喜欢的背景下玩免费的拼图游戏。<br>- 专属自己的拼图册:已进行或已完成的拼图收集在一个地方.<br>- 金币系统:完成拼图即可获取金币,获得更多独特的收藏拼图.<br><br>拼图是最经典的益智游戏之一。它适合任何年龄段的人,训练大脑,打发时间,放松心情.<br>现在就下载完成精美的拼图吧,让每一天都轻松愉快!' ,   
            '欢迎来到美妙的拼图世界，成千上万款拼图游戏让你远离生活烦恼，找回内心平静，享受轻松时光！您可以通过选择碎片数来选择每个谜题的难度。此外，拼图应用十分便携，内含各种拼图游戏，却不会有任何碎片丢失。每天都一起拼出明亮而有魔力的全新拼图，享受无穷乐趣！<br><br>🧩特点：<br>- 每日拼图:每天更新免费拼图,试试解开它<br>- 没有丢失的碎片:根据需要完成每个拼图高清拼图，因为根本没有丢失的碎片。<br>- 难度选择:选择不同碎片数量。碎片越多，游戏越难,成为拼图高手!<br>- 各种系列图片:动物,风景,美食,花卉,房屋,地标等<br>- 自定义背景：选择在喜欢的背景下玩免费的拼图游戏。<br>- 专属自己的拼图册:已进行或已完成的拼图收集在一个地方.<br>- 金币系统:完成拼图即可获取金币,获得更多独特的收藏拼图.<br><br>拼图是最经典的益智游戏之一。它适合任何年龄段的人,训练大脑,打发时间,放松心情.<br>现在就下载完成精美的拼图吧,让每一天都轻松愉快!' ,   
            '欢迎来到美妙的拼图世界，成千上万款拼图游戏让你远离生活烦恼，找回内心平静，享受轻松时光！您可以通过选择碎片数来选择每个谜题的难度。此外，拼图应用十分便携，内含各种拼图游戏，却不会有任何碎片丢失。每天都一起拼出明亮而有魔力的全新拼图，享受无穷乐趣！<br><br>🧩特点：<br>- 每日拼图:每天更新免费拼图,试试解开它<br>- 没有丢失的碎片:根据需要完成每个拼图高清拼图，因为根本没有丢失的碎片。<br>- 难度选择:选择不同碎片数量。碎片越多，游戏越难,成为拼图高手!<br>- 各种系列图片:动物,风景,美食,花卉,房屋,地标等<br>- 自定义背景：选择在喜欢的背景下玩免费的拼图游戏。<br>- 专属自己的拼图册:已进行或已完成的拼图收集在一个地方.<br>- 金币系统:完成拼图即可获取金币,获得更多独特的收藏拼图.<br><br>拼图是最经典的益智游戏之一。它适合任何年龄段的人,训练大脑,打发时间,放松心情.<br>现在就下载完成精美的拼图吧,让每一天都轻松愉快!' ,   
            ],
        appleURL:'https://apps.apple.com/us/app/jigsaw-puzzles-daily/id6448161041',
        googleURL:'https://play.google.com/store/apps/details?id=com.bigcake.jigsaw.puzzles&gl=US&hl=en-US&pli=1',
        downloads:'5M+',
        imgURL:'../../static/img/games/jp_icon.png',
        posterImgURL:'../../../static/img/games/jp-poster-img.png',
        comments:[
            [
                '../../static/img/games/user-comment2.jp.png',
                '../../static/img/games/user-comment3.jp.png',
                '../../static/img/games/user-comment4.jp.png',
            ], [
                '../../static/img/games/user-comment6.jp.png',
                '../../static/img/games/user-comment7.jp.png',
                '../../static/img/games/user-comment8.jp.png',
            ],
        ],
    },
    cbn:{
        gameKey:'cbn',
        name:['我的涂色本','我的涂色本','Color by Number',],
        subTitle:['追寻艺术之美：我的涂色本','追寻艺术之美：我的涂色本','追寻艺术之美：我的涂色本',],
        info:[
            '欢迎进入[我的涂色本]的艺术殿堂，这里是那些对生活充满热情、渴望内心宁静和探索创造力的灵魂的天堂。在这个数字填色书游戏中，您将迈出一段富有创意的旅程，发现内心的色彩和美感。<br><br>游戏特色：<br>-艺术无界：[我的涂色本]提供了数以千计的精美涂色页面，每一张都是一位艺术家的精心创作。从大自然的壮丽风光到充满生命的动植物，再到抽象的幻想世界，您可以自由选择并发挥创造力，用色彩点亮画布上的每一个细节。<br>-独特个性：我们鼓励您以自己的方式表达创造力。除了填色，您还可以选择独特的背景和精美的相框，为您的作品增添个性。从宁静的森林到繁华的城市街道，您可以在不同的背景下发现灵感。<br>-灵感之源：填色是一种充满灵感的活动，有助于您找到内心的宁静，享受创造的过程。在[我的涂色本]中，您可以尽情释放心灵，追寻艺术之美，享受独特的放松和愉悦。<br>-游戏之趣：收集星星宝箱和金币，解锁新颜色、背景和相框，让您的填色体验更加多彩。发现游戏中的惊喜，为您的填色作品增添更多乐趣。<br><br>[我的涂色本]是一个灵感之源，是艺术的探索之旅，是发现内心的色彩和美感的旅程。不论您是在寻找愉悦、内心的宁静，还是在追求艺术的美感，[我的涂色本]都是您的理想选择。<br><br>下载[我的涂色本]，探索艺术之美，享受填色的愉悦。我们鼓励您发挥创意，与我们一同创造独特的艺术作品，让生活更加多姿多彩。' ,   
            '欢迎进入[我的涂色本]的艺术殿堂，这里是那些对生活充满热情、渴望内心宁静和探索创造力的灵魂的天堂。在这个数字填色书游戏中，您将迈出一段富有创意的旅程，发现内心的色彩和美感。<br><br>游戏特色：<br>-艺术无界：[我的涂色本]提供了数以千计的精美涂色页面，每一张都是一位艺术家的精心创作。从大自然的壮丽风光到充满生命的动植物，再到抽象的幻想世界，您可以自由选择并发挥创造力，用色彩点亮画布上的每一个细节。<br>-独特个性：我们鼓励您以自己的方式表达创造力。除了填色，您还可以选择独特的背景和精美的相框，为您的作品增添个性。从宁静的森林到繁华的城市街道，您可以在不同的背景下发现灵感。<br>-灵感之源：填色是一种充满灵感的活动，有助于您找到内心的宁静，享受创造的过程。在[我的涂色本]中，您可以尽情释放心灵，追寻艺术之美，享受独特的放松和愉悦。<br>-游戏之趣：收集星星宝箱和金币，解锁新颜色、背景和相框，让您的填色体验更加多彩。发现游戏中的惊喜，为您的填色作品增添更多乐趣。<br><br>[我的涂色本]是一个灵感之源，是艺术的探索之旅，是发现内心的色彩和美感的旅程。不论您是在寻找愉悦、内心的宁静，还是在追求艺术的美感，[我的涂色本]都是您的理想选择。<br><br>下载[我的涂色本]，探索艺术之美，享受填色的愉悦。我们鼓励您发挥创意，与我们一同创造独特的艺术作品，让生活更加多姿多彩。' ,   
            '欢迎进入[我的涂色本]的艺术殿堂，这里是那些对生活充满热情、渴望内心宁静和探索创造力的灵魂的天堂。在这个数字填色书游戏中，您将迈出一段富有创意的旅程，发现内心的色彩和美感。<br><br>游戏特色：<br>-艺术无界：[我的涂色本]提供了数以千计的精美涂色页面，每一张都是一位艺术家的精心创作。从大自然的壮丽风光到充满生命的动植物，再到抽象的幻想世界，您可以自由选择并发挥创造力，用色彩点亮画布上的每一个细节。<br>-独特个性：我们鼓励您以自己的方式表达创造力。除了填色，您还可以选择独特的背景和精美的相框，为您的作品增添个性。从宁静的森林到繁华的城市街道，您可以在不同的背景下发现灵感。<br>-灵感之源：填色是一种充满灵感的活动，有助于您找到内心的宁静，享受创造的过程。在[我的涂色本]中，您可以尽情释放心灵，追寻艺术之美，享受独特的放松和愉悦。<br>-游戏之趣：收集星星宝箱和金币，解锁新颜色、背景和相框，让您的填色体验更加多彩。发现游戏中的惊喜，为您的填色作品增添更多乐趣。<br><br>[我的涂色本]是一个灵感之源，是艺术的探索之旅，是发现内心的色彩和美感的旅程。不论您是在寻找愉悦、内心的宁静，还是在追求艺术的美感，[我的涂色本]都是您的理想选择。<br><br>下载[我的涂色本]，探索艺术之美，享受填色的愉悦。我们鼓励您发挥创意，与我们一同创造独特的艺术作品，让生活更加多姿多彩。' ,   
            ],
        appleURL:'#',
        googleURL:'https://play.google.com/store/apps/details?id=color.paint.by.number.pgmaker&hl=en-US&gl=US',
        downloads:'1M+',
        imgURL:'../../static/img/games/cbn_icon.png',
        posterImgURL:'../../../static/img/games/cbn-poster-img.png',
        comments:[
            [
                '../../static/img/games/user-comment2.cbn.png',
                '../../static/img/games/user-comment3.cbn.png',
                '../../static/img/games/user-comment4.cbn.png',
            ], [
                '../../static/img/games/user-comment6.cbn.png',
                '../../static/img/games/user-comment7.cbn.png',
                '../../static/img/games/user-comment8.cbn.png',
            ],
        ],
    },
    db:{
        gameKey:'db',
        name:['每日泡泡','每日泡泡','Daily Bubble',],
        subTitle:['快来玩数字泡泡连线，让你的大脑休息一下！','快来玩数字泡泡连线，让你的大脑休息一下！','快来玩数字泡泡连线，让你的大脑休息一下！',],
        info:[
            '“数字泡泡连线”是一个令人上瘾的放松数字泡泡合并益智游戏。🧩连接相同编号的气泡以合并它们！创建最长的链接并将它们合并以获得更多积分！🏆挑战你的头脑并解决难题，然后你会发现它们简单而令人兴奋！<br><br>怎么玩？<br> ⁃ 在任意八个方向（上,下,左,右或对角线）上滑动相同的数字以合并它们。<br> ⁃ 相同数字的气泡将合并为更大数字的气泡。<br> ⁃ 没有时间限制！<br> ⁃ 只是滑动！<br><br>特征：<br> ⁃ 精美易用，简单明了，没有压力，没有时间限制。<br> ⁃ 挑战并打破你的最高分。<br> ⁃ 玩法简单。经典的合并数字游戏，适合所有年龄段！<br> ⁃ 美丽多样的背景图片。<br> ⁃ 多种材质的气泡。如：铁、水晶、木头等<br><br>快来玩这个游戏，成为数字泡泡游戏的大师吧！' ,   
            '“数字泡泡连线”是一个令人上瘾的放松数字泡泡合并益智游戏。🧩连接相同编号的气泡以合并它们！创建最长的链接并将它们合并以获得更多积分！🏆挑战你的头脑并解决难题，然后你会发现它们简单而令人兴奋！<br><br>怎么玩？<br> ⁃ 在任意八个方向（上,下,左,右或对角线）上滑动相同的数字以合并它们。<br> ⁃ 相同数字的气泡将合并为更大数字的气泡。<br> ⁃ 没有时间限制！<br> ⁃ 只是滑动！<br><br>特征：<br> ⁃ 精美易用，简单明了，没有压力，没有时间限制。<br> ⁃ 挑战并打破你的最高分。<br> ⁃ 玩法简单。经典的合并数字游戏，适合所有年龄段！<br> ⁃ 美丽多样的背景图片。<br> ⁃ 多种材质的气泡。如：铁、水晶、木头等<br><br>快来玩这个游戏，成为数字泡泡游戏的大师吧！' ,   
            '“数字泡泡连线”是一个令人上瘾的放松数字泡泡合并益智游戏。🧩连接相同编号的气泡以合并它们！创建最长的链接并将它们合并以获得更多积分！🏆挑战你的头脑并解决难题，然后你会发现它们简单而令人兴奋！<br><br>怎么玩？<br> ⁃ 在任意八个方向（上,下,左,右或对角线）上滑动相同的数字以合并它们。<br> ⁃ 相同数字的气泡将合并为更大数字的气泡。<br> ⁃ 没有时间限制！<br> ⁃ 只是滑动！<br><br>特征：<br> ⁃ 精美易用，简单明了，没有压力，没有时间限制。<br> ⁃ 挑战并打破你的最高分。<br> ⁃ 玩法简单。经典的合并数字游戏，适合所有年龄段！<br> ⁃ 美丽多样的背景图片。<br> ⁃ 多种材质的气泡。如：铁、水晶、木头等<br><br>快来玩这个游戏，成为数字泡泡游戏的大师吧！' ,   
            ],
        appleURL:'#',
        googleURL:'https://play.google.com/store/apps/details?id=com.bigcake.android.bubbledaily&gl=US&hl=en-US&pli=1',
        downloads:'10M+',
        imgURL:'../../static/img/games/db_icon.png',
        posterImgURL:'../../../static/img/games/db-poster-img.png',
        comments:[
            [
                '../../static/img/games/user-comment2.db.png',
                '../../static/img/games/user-comment3.db.png',
                '../../static/img/games/user-comment4.db.png',
            ], [
                '../../static/img/games/user-comment6.db.png',
                '../../static/img/games/user-comment7.db.png',
                '../../static/img/games/user-comment8.db.png',
            ],
        ],
    },
}

const slidesList = [
    {
        redirect: '/games/bpd',
        image: '../../../static/img/index/carousel_bpd.jpg',
    },
    {
        redirect: '/games/ssc',
        image: '../../../static/img/index/carousel_ssc.jpg',
    },
    {
        redirect: '/games/db',
        image: '../../../static/img/index/carousel_db.jpg',
    },
    {
        redirect: '/games/jp',
        image: '../../../static/img/index/carousel_jp.jpg',
    },
];

// 用户评论图片列表
// 一组3个图片
let userComments = [
    [
        '../../../static/img/user-comment1.png',
        '../../../static/img/user-comment2.png',
        '../../../static/img/user-comment3.png',
    ],
    [
        '../../../static/img/user-comment4.png',
        '../../../static/img/user-comment5.png',
        '../../../static/img/user-comment6.png',
    ],
    [
        '../../../static/img/user-comment7.png',
        '../../../static/img/user-comment8.png',
        '../../../static/img/user-comment9.png',
    ],
];
const allUserComments = [];
Object.values(games).forEach(g => {
    for (const comments of g.comments) {
        if (comments.length) {
            allUserComments.push(comments);
        }
    }
});
allUserComments.sort(() => Math.random() - 0.5);
userComments = allUserComments.slice(0, 3);
// console.log('allUserComments:', allUserComments);



export {
    index,
    games,
    slidesList,
    userComments,
}



// WEBPACK FOOTER //
// ./src/assets/game_data.js